let config = {
  previewMaxWidth: 200,
  previewMaxHeight: 200,
  previewMinWidth: null,
  previewMinHeight: null,
  previewCrop: false,
  googleKey: null,
};

export default config;
